import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue";
var _hoisted_1 = {
  key: 0,
  style: {
    "height": "600px",
    "overflow": "auto"
  }
};
var _hoisted_2 = ["src", "alt"];
var _hoisted_3 = {
  key: 4,
  style: {
    "text-align": "center",
    "padding": "50px"
  }
};
var _hoisted_4 = {
  key: 5,
  style: {
    "text-align": "center",
    "padding": "50px"
  }
};
var _hoisted_5 = {
  class: "dialog-footer"
};
import { ref, computed, watch } from 'vue';
import { ElMessage } from 'element-plus';
import { Loading } from '@element-plus/icons-vue';
import VueOfficeDocx from '@vue-office/docx';
import VueOfficeExcel from '@vue-office/excel';
import VueOfficePdf from '@vue-office/pdf';

// 定义props

export default {
  __name: 'previewfile',
  props: {
    // 文件URL（必需）
    url: {
      type: String,
      required: true
    },
    // 是否显示预览对话框
    visible: {
      type: Boolean,
      default: false
    },
    // 对话框标题
    title: {
      type: String,
      default: '文件预览'
    },
    // 是否显示下载按钮
    showDownloadBtn: {
      type: Boolean,
      default: true
    }
  },
  emits: ['update:visible', 'close', 'download', 'error'],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var props = __props;

    // 定义emit事件
    var emit = __emit;

    // 响应式数据
    var loading = ref(false);
    var dialogVisible = ref(false);

    // 计算属性
    var imageTypes = computed(() => ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg']);

    // 推断文件类型
    var fileType = computed(() => {
      // 从URL中提取文件后缀
      var url = props.url;
      if (!url) return '';
      var lastDotIndex = url.lastIndexOf('.');
      if (lastDotIndex === -1) return '';
      var extension = url.substring(lastDotIndex + 1).toLowerCase();
      return extension;
    });

    // 不支持预览的类型
    var unsupportedType = computed(() => {
      var type = fileType.value;
      return !['pdf', 'doc', 'docx', 'xls', 'xlsx', ...imageTypes.value].includes(type);
    });

    // 监听visible变化
    watch(() => props.visible, newVal => {
      dialogVisible.value = newVal;
      if (newVal) {
        loading.value = true;
      }
    });

    // 监听dialogVisible变化
    watch(dialogVisible, newVal => {
      emit('update:visible', newVal);
    });

    // 渲染完成回调
    var onPdfRendered = () => {
      loading.value = false;
      console.log("PDF渲染完成");
    };
    var onDocxRendered = () => {
      loading.value = false;
      console.log("Word文档渲染完成");
    };
    var onExcelRendered = () => {
      loading.value = false;
      console.log("Excel文档渲染完成");
    };
    var onImageLoaded = () => {
      loading.value = false;
      console.log("图片加载完成");
    };

    // 错误处理
    var onPreviewError = error => {
      loading.value = false;
      console.error("文件预览出错:", error);
      ElMessage({
        type: "error",
        message: "文件预览失败: " + (error.message || "未知错误")
      });
      emit('error', error);
    };

    // 关闭预览
    var handleClose = () => {
      dialogVisible.value = false;
      emit('close');
    };

    // 下载文件
    var handleDownload = () => {
      window.open(props.url, '_blank');
      emit('download', props.url);
    };
    return (_ctx, _cache) => {
      var _component_el_button = _resolveComponent("el-button");
      var _component_el_icon = _resolveComponent("el-icon");
      var _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => dialogVisible.value = $event),
        title: __props.title,
        width: "80%",
        height: "80%",
        onClose: handleClose,
        "destroy-on-close": ""
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createVNode(_component_el_button, {
          onClick: handleClose
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("关闭")])),
          _: 1
        }), __props.showDownloadBtn && !unsupportedType.value ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          onClick: handleDownload,
          type: "primary"
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode(" 下载 ")])),
          _: 1
        })) : _createCommentVNode("", true)])]),
        default: _withCtx(() => [__props.url ? (_openBlock(), _createElementBlock("div", _hoisted_1, [fileType.value === 'pdf' ? (_openBlock(), _createBlock(_unref(VueOfficePdf), {
          key: 0,
          src: __props.url,
          style: {
            "width": "100%",
            "height": "100%"
          },
          onRendered: onPdfRendered,
          onError: onPreviewError
        }, null, 8, ["src"])) : ['docx'].includes(fileType.value) ? (_openBlock(), _createBlock(_unref(VueOfficeDocx), {
          key: 1,
          src: __props.url,
          style: {
            "width": "100%",
            "height": "100%"
          },
          onRendered: onDocxRendered,
          onError: onPreviewError
        }, null, 8, ["src"])) : ['xls', 'xlsx'].includes(fileType.value) ? (_openBlock(), _createBlock(_unref(VueOfficeExcel), {
          key: 2,
          src: __props.url,
          style: {
            "width": "100%",
            "height": "100%"
          },
          onRendered: onExcelRendered,
          onError: onPreviewError
        }, null, 8, ["src"])) : imageTypes.value.includes(fileType.value) ? (_openBlock(), _createElementBlock("img", {
          key: 3,
          src: __props.url,
          alt: __props.title,
          style: {
            "max-width": "100%",
            "height": "auto",
            "display": "block",
            "margin": "0 auto"
          },
          onLoad: onImageLoaded,
          onError: onPreviewError
        }, null, 40, _hoisted_2)) : (_openBlock(), _createElementBlock("div", _hoisted_3, [_cache[2] || (_cache[2] = _createElementVNode("p", {
          style: {
            "margin-bottom": "40px",
            "font-size": "20px"
          }
        }, "该文件类型暂不支持在线预览。", -1)), _createVNode(_component_el_button, {
          onClick: handleDownload,
          type: "primary"
        }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [_createTextVNode(" 下载文件 ")])),
          _: 1
        })])), loading.value && !unsupportedType.value ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_el_icon, {
          class: "is-loading",
          size: "24"
        }, {
          default: _withCtx(() => [_createVNode(_unref(Loading))]),
          _: 1
        }), _cache[3] || (_cache[3] = _createElementVNode("p", null, "文件加载中...", -1))])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["modelValue", "title"]);
    };
  }
};